var render = function render(_c,_vm){return _c('footer',{staticClass:"footer powered-by has-secondary-font"},[(!_vm.props.whiteLabel)?_c('div',{staticClass:"container"},[_vm._m(0)]):_vm._e()])
}
var staticRenderFns = [function (_c,_vm){return _c('div',{staticClass:"content has-text-centered is-size-7"},[_c('p',[_vm._v(" Powered by ")]),_c('a',{attrs:{"href":"https://www.kydemy.com"}},[_c('img',{attrs:{"alt":"Kydemy","src":require("../../assets/powered-by-kydemy.png")}})])])
}]

export { render, staticRenderFns }